import { DefaultTheme } from "styled-components";

const DEFAULT_THEME: DefaultTheme = {
  color: {
    action: '#0071b2',
    background: '#0071b2',
  }
}

export default DEFAULT_THEME